import { useState, useEffect, useContext } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import Header from '../../components/header';
import { getTickets } from '../../services/product';
import { Information } from '../../components/information';
import { useNavigate } from 'react-router-dom';
import { TransactionContext } from '../../contexts/TransactionContext';
import { useTranslation } from 'react-i18next';
import { Tickets } from '../../components/tickets';
import Event from '../../components/event';
import { EVENTID } from '../../helpers/constants';
import { Alert } from '../../components/modal';
import { useError } from '../../hooks/useError';
export const Cart = () => {
  const [t, i18n] = useTranslation();
  const navigate = useNavigate();
  const { setCart, firstStep, setUtm } = useContext(TransactionContext);
  const [tickets, setTickets] = useState([]);
  const { goToFieldWithError } = useError();

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    goToFieldWithError('home-cp');
  };

  //const maxCount = 3;

  const updateTicketCount = (value, index, maxCount) =>
    setTickets((prevState) => {
      const newState = [...prevState];
      const currentCount = newState[index].count;
      const newCount = currentCount + value;
      if (
        newState[index] === undefined ||
        newCount > maxCount ||
        newCount < 0
      ) {
        return newState;
      }
      newState[index] = { ...newState[index], count: newCount };
      return newState;
    });

  const handleAddTicket = (e, index) => {
    const ticket = tickets[index];
    //console.log(ticket);

    const ticketInCart = tickets.find((x) => x.count > 0);

    if (!(ticketInCart && ticketInCart.id !== ticket.id)) {
      const isCartEmpty = tickets.every((ticket) => ticket.count === 0);
      const valueToAdd = isCartEmpty ? ticket.purchaseMin : 1;
      updateTicketCount(valueToAdd, index, ticket.purchaseMax);
    }
  };

  const handleRemoveTicket = (e, index) => {
    const ticket = tickets[index];
    const valueToAdd =
      ticket.count === ticket.purchaseMin ? -ticket.purchaseMin : -1;
    if (ticket.count > 0) {
      updateTicketCount(valueToAdd, index);
    }
  };

  const handleBuy = (e) => {
    e.preventDefault();

    const ticketToBuy = tickets.filter((ticket) => ticket.count > 0);
    if (ticketToBuy.length > 0) {
      setCart(ticketToBuy);
      navigate('/pagamento');
    }
  };

  useEffect(() => {
    const fetchTickets = async () => {
      i18n.changeLanguage('pt');
      document.documentElement.setAttribute('lang', t('language'));
      document.title = t('title');
      const urlParams = new URLSearchParams(window.location.search);

      const currentUtm = {
        utmSource: urlParams.get('utm_source') || 'outros',
        utmMedium: urlParams.get('utm_medium') || 'outros',
        utmCampaign: urlParams.get('utm_campaign') || 'outros',
        utmTerm: urlParams.get('utm_term') || 'outros',
        utmContent: urlParams.get('utm_content') || 'outros',
      };
      setUtm(currentUtm);
      const response = await getTickets(EVENTID);
      const newTickets = response?.map((ticket) => ({
        ...ticket,
        count: 0,
      }));
      setTickets(newTickets);
      firstStep();
    };
    fetchTickets();
  }, []);

  const modal = (
    <Alert
      isOpen={open}
      toggle={closeModal}
      message={message}
    />
  );

  return (
    <section className='d-flex flex-column justify-content-center align-items-center w-100'>
      {modal}
      <Header />
      <Card>
        <CardBody>
          <Row>
            <Col
              md={6}
              className='d-flex flex-column gap-1'
            >
              <section
                className='mb-3'
                id='home-cp'
              >
                <Event t={t} />
                <Information t={t} />
              </section>
            </Col>
            <Col
              md={6}
              className='d-flex flex-column gap-1'
            >
              <Tickets
                handleAdd={handleAddTicket}
                handleRemove={handleRemoveTicket}
                handleBuy={handleBuy}
                tickets={tickets}
                t={t}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </section>
  );
};
